import modelBase from '../../models/model-base.model';

var userRoleModel = {
  getUserRoleList: (successCallBack, failureCallBack) => {
    modelBase.get(successCallBack, failureCallBack, '/api/codemaster/userrole');
  }
}

export default userRoleModel;
